import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { DELETE_SHIPMENT, GET_SHIPMENT_LIST } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { AxiosResponse } from "axios";
import { IDeleteShipmentRequest } from "@/types/apiResponse.types";
import { toast } from "react-toastify";
import { TDeleteShipmentData } from "@/types/apiParam.types";

export const useDeleteShipmentRequest = (): UseMutateAsyncFunction<
  AxiosResponse<IDeleteShipmentRequest>,
  Error,
  TDeleteShipmentData,
  unknown
> => {
  const queryClient = useQueryClient();
  const { mutateAsync: deleteShipment } = useMutation({
    mutationFn: (data: TDeleteShipmentData) =>
      apiRequest(DELETE_SHIPMENT, "delete", data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_SHIPMENT_LIST],
        exact: false,
      });
      toast.success("Parcel deleted successfully ", { position: "top-center" });
    },
    onError: () => {
      toast.error("Error occured", { position: "top-center" });
    },
  });
  return deleteShipment;
};
